import classes from "./Backdrop.module.css";

const Backdrop = () => <div className={classes.backdrop}></div>;

export default Backdrop;
